import { Typography } from '@mui/material';
import { FC } from 'react';

import { ContentTitleStyled } from './content-title.styles';

interface ContentTitleProps {
  title: string;
}

export const ContentTitle: FC<ContentTitleProps> = ({ title }) => (
  <ContentTitleStyled>
    <Typography variant="h6">{title}</Typography>
  </ContentTitleStyled>
);
